import classNames from 'classnames'

import type { ReactElement, ReactNode } from 'react'

import './styles.scss'

interface Props {
  children?: ReactNode
  className?: string
}

const LayoutGroups = ({ children, className }: Props): ReactElement => {
  const classnames = classNames('layout-groups', className)

  return <div className={classnames}>{children}</div>
}

export default LayoutGroups
